"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
import OSS from "ali-oss";
const UUID = require("uuid");
export class UploadFeedbackManagerWrap {
  //启动任务
  start(fileList) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get("api://base.auth/api/v7/file/sts", {
          params: {
            type: "comment"
          }
        });
        this.client = new OSS({
          region: "oss-cn-beijing",
          accessKeyId: response.data.data.accessKeyId,
          accessKeySecret: response.data.data.accessKeySecret,
          bucket: response.data.data.bucketName,
          stsToken: response.data.data.securityToken
        });
        this.ossId = response.data.data.id;
        let FileRealLists = [];
        fileList.forEach((file) => {
          let random = UUID.v4().replaceAll("-", "").substring(0, 10);
          const name = random + file.name;
          FileRealLists.push({
            path: response.data.data.path + "/" + name,
            file
          });
        });
        return yield Promise.all(
          FileRealLists.map((file, i) => {
            return this.RealUpLoad(file.path, file.file);
          })
        );
      } catch (error) {
      }
    });
  }
  RealUpLoad(path, file) {
    return __async(this, null, function* () {
      return new Promise((resolve, reject) => {
        this.client.multipartUpload(path, file, {}).then((result) => {
          resolve(__spreadProps(__spreadValues({}, result), {
            "real_name": file.name,
            "ossId": this.ossId
          }));
        }).catch((error) => {
          reject();
        });
      });
    });
  }
}
